import { useTranslation } from 'react-i18next';

export default function GracePeriodSection({
  renewalDate,
}: {
  renewalDate: string;
}) {
  const { t } = useTranslation('app');

  return (
    <div className="flex flex-col gap-1.5x border-t border-gray pt-2x px-3x">
      <p className="text-title_4"> {t('endDate')}</p>
      <div className="flex flex-col gap-x">
        <p className="text-body_2 text-gray__dark_1">
          {t('autoRenewalCanceled')}
        </p>
        <p className="text-link text-gray__dark_2">{renewalDate}</p>
      </div>
    </div>
  );
}
